var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAskRecruiterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 211.29,
    height: 156.372,
    viewBox: "0 0 211.29 156.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-ask-recruiter-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4401",
    "data-name": "Rectangle 4401",
    width: 211.29,
    height: 156.372,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23781",
    "data-name": "Group 23781",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23780",
    "data-name": "Group 23780",
    transform: "translate(0 0.002)",
    clipPath: "url(#clip-path-ask-recruiter-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22849",
    "data-name": "Path 22849",
    d: "M105.646,1359.962c58.346,0,105.645,2.3,105.645,5.153s-47.3,5.153-105.645,5.153S0,1367.966,0,1365.115s47.3-5.153,105.646-5.153",
    transform: "translate(0 -1213.897)",
    fill: "#e3e7fb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22850",
    "data-name": "Path 22850",
    d: "M626.052,501.031c-2.654-.94-2.288.985-2.781,2.936a3.674,3.674,0,0,1,1.876,1.918c.755-.544,1.315-.4,1.831-1.155.853-1,1.929-2.95.853-3.088a2.577,2.577,0,0,1-1.249,1.388,6.383,6.383,0,0,1,.269-1.273,4.849,4.849,0,0,1,1.017-1.721q1.492-.372,1.211-.888-1.85-.333-3.027,1.884",
    transform: "translate(-556.329 -445.498)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22851",
    "data-name": "Path 22851",
    d: "M623.635,890.028c-1.308,3.687-2.414,12.069-2.825,25.159-.336,6.36.583,14.815,1.772,25.928a10.347,10.347,0,0,0,4.2.592c1.875-15.341,2.279-21.857,1.367-26.121a74.8,74.8,0,0,0,4.7-13.623,109.44,109.44,0,0,0,2.429,15.578q3.351,9.274,9.993,24.307a7.161,7.161,0,0,0,4.126-.807c-2.093-10.958-3.505-22.309-7.116-24.448,2.751-13.5,1.465-21.412-1.144-26.41a60.069,60.069,0,0,1-17.505-.155",
    transform: "translate(-554.069 -794.436)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22852",
    "data-name": "Path 22852",
    d: "M521.125,558.016c-.89,9.754,1.158,8.933,1.076,22.571a51.9,51.9,0,0,0,12.385.592c-.313,1.311-.559,2.481-.747,3.362a3.994,3.994,0,0,1,3.573,1.377c1.016-1.584,1.906-3.05,2.668-4.413,2.437-4.331,3.677-7.641,4.074-10.4,2.534-16.3-1.405-21.634-11.294-21.938-.651,1.6-4.223,2.636-5.255,2.536-.733-.418-1.077-1.573-1.659-2.651a18.319,18.319,0,0,0-7.676,3.524,43.222,43.222,0,0,0,3.542-6.8,4.066,4.066,0,0,0-2.482-2.432q-15.807,13.333-11.182,16.718,4.922,1.977,12.976-2.055",
    transform: "translate(-452.636 -484.994)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22853",
    "data-name": "Path 22853",
    d: "M584.914,1384.187a44.764,44.764,0,0,0,7.557.237c1.495-.281,1.025-1.155.352-2.532a5.189,5.189,0,0,1-3.977-.422,10,10,0,0,1-4.993,1.341c-.964.577-.651,1.2,1.061,1.377m27.462,1.141a20.345,20.345,0,0,0,4.365-1.422c1.039-.644.493-1.3-.464-2.34a5.13,5.13,0,0,1-3.931.741c-1.069,1.436-4.425.755-4.783,1.747-.457,1.85,3.9,1.51,4.813,1.273",
    transform: "translate(-520.663 -1233.094)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22854",
    "data-name": "Path 22854",
    d: "M608.028,638.034c.808-3.383,2.026-7.707,3.633-10.439a36.209,36.209,0,0,1-.336-10,30.721,30.721,0,0,0-1.279,9.966,38.116,38.116,0,0,0-2.916,10.514l.9-.045m-18.648-25.21a26.112,26.112,0,0,1,6.353-5.775,17.646,17.646,0,0,0-4.021,2.388q-1.065,1.688-2.333,3.388",
    transform: "translate(-526.078 -541.849)",
    fill: "#1c2a47",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22855",
    "data-name": "Path 22855",
    d: "M673.926,495.56c1.032.1,4.6-.937,5.255-2.536a7.581,7.581,0,0,1-1.151-2.888,12.966,12.966,0,0,0,.6-1.159q3.621-1.544,1.5-3.021a4.2,4.2,0,0,0-1.48,1.381.968.968,0,0,1-.733-.722A28.269,28.269,0,0,0,679.5,483.1c-.756-1.747-3.169-2.439-6.511-2.647-.315.833-.621,1.718-.9,2.658-.68.415-.986,2.377-.9,4.724q-.774,1.838,1.981,2.547a7.035,7.035,0,0,1-.912,2.532c.583,1.077.926,2.232,1.659,2.651",
    transform: "translate(-598.956 -428.847)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22856",
    "data-name": "Path 22856",
    d: "M678.4,445.682c3.341.207,5.755.9,6.511,2.647a28.282,28.282,0,0,1-1.586,3.521.968.968,0,0,0,.733.722,4.2,4.2,0,0,1,1.48-1.381q2.119,1.477-1.5,3.021a12.988,12.988,0,0,1-.6,1.159,6.041,6.041,0,0,0,4.313-2.144c3.094-3.946.957-6.271-.254-7.2.262-4.442-6.831-1.833-9.613-4.528-1.6,1.488-.456,3.957.516,4.184",
    transform: "translate(-604.369 -394.079)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22857",
    "data-name": "Path 22857",
    d: "M751.4,896.854c.113-.482.209-.926.306-1.311l-.9.045c-.164.94-.314,2.088-.463,3.45.164-.044.366-.089.613-.133.12-.563.268-1.259.434-2.014a.089.089,0,0,0,.007-.037",
    transform: "translate(-669.755 -799.358)",
    fill: "#2c2066",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22858",
    "data-name": "Path 22858",
    d: "M690.441,571.962a9.5,9.5,0,0,1-2.557.1,8.851,8.851,0,0,1-.381,1.448,5.628,5.628,0,0,0,2.938-1.547",
    transform: "translate(-613.662 -510.531)",
    fill: "#ed7d57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22859",
    "data-name": "Path 22859",
    d: "M660.518,1368.133a4.81,4.81,0,0,1,.194,1.792,5.106,5.106,0,0,0,3.282-.555,7.13,7.13,0,0,1-.6-1.755,8.032,8.032,0,0,1-2.877.519m-19.9,1.406a10.487,10.487,0,0,1-.03-1.6,10.227,10.227,0,0,1-2.8-.392,3.619,3.619,0,0,1-.6,1.622,5.1,5.1,0,0,0,3.431.37",
    transform: "translate(-568.752 -1220.668)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22860",
    "data-name": "Path 22860",
    d: "M750.258,926.585a25.521,25.521,0,0,0-.957,4.279c.718,1.955,1.622,3.05,2.714,3.3,1.255-.082,1.517-1.029,1.831-1.7a3.226,3.226,0,0,1-1.271-2.073c.7-.518.883-1.081.561-1.666.142-.326.268-.615.388-.881a2.9,2.9,0,0,0-2.339-1.288c-.306-.007-.612.014-.927.029",
    transform: "translate(-668.823 -827.039)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22861",
    "data-name": "Path 22861",
    d: "M652.959,757.242q-9.755-.366-15.271-2.243c-.083-.563-.15-1.111-.217-1.666a68.923,68.923,0,0,0,15.516,2.229c-.029.555-.037,1.11-.029,1.68",
    transform: "translate(-569.005 -672.422)",
    fill: "#1c2a47",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22862",
    "data-name": "Path 22862",
    d: "M651.5,613.1q-11.134-.1-15.906-2.088c-.015-.508-.03-1.044-.022-1.629q5.382,2.154,16.2,1.962c-.105.563-.2,1.148-.277,1.755m-9.224-13.982c1.032.1,4.6-.937,5.255-2.536l.7.033q-.907,2.593-6.039,3.25a6.641,6.641,0,0,1-2.085-3.295c.171-.041.343-.074.516-.1.583,1.077.926,2.232,1.659,2.651",
    transform: "translate(-567.309 -532.403)",
    fill: "#1c2a47",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22863",
    "data-name": "Path 22863",
    d: "M1061.284,538.617c-1.278-1.185-4.851-2.492-6.981-3.136a50.657,50.657,0,0,0-7.288-.37q-6.682-.061-14.358.141c-5.061-2.44-6.406-2.651-8.962-3.8-.755-.337-2.13-1.055-3.229-1.644a3.967,3.967,0,0,0-1.353,2.317,51.673,51.673,0,0,0,10.778,8.252,64.33,64.33,0,0,0,10.233,1.84q1.2,7.6,1.816,14.641a64.485,64.485,0,0,0-1.211,10.122q11.716,1.71,18.8.089a43.7,43.7,0,0,0-1.084-4.931c.515-6.352,1.338-10.476,1.779-13.412a32.263,32.263,0,0,0,4.1,6.556,72.744,72.744,0,0,0-2.834,9.432,4.1,4.1,0,0,0,2.362,1.459c1.241-2.132,3.94-7.019,4.642-10.662.5-2.918-5.405-14.6-7.206-16.892",
    transform: "translate(-909.655 -472.903)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22864",
    "data-name": "Path 22864",
    d: "M1266.443,482.364a16.187,16.187,0,0,1,5.695.355,4.889,4.889,0,0,1-.657-1.636c-4.65-.688-4.193-1.829-4.021-2.351.934-2.469,1.5-4.031.829-4.776a2.334,2.334,0,0,0-1.36,1.625c-.3-.174-.666-.407-.718-.737-.112-.988-.074-3.047-1.218-3.221-.224.9-.426,1.866-.6,2.88-.658.518-.725,2.606-.329,5.038q-.572,2.011,2.391,2.4Z",
    transform: "translate(-1128.082 -420.971)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22865",
    "data-name": "Path 22865",
    d: "M1263.141,443.044c-.172.522-.628,1.662,4.021,2.351a6.309,6.309,0,0,0,4.216-2.773c2.721-4.5.194-6.652-1.181-7.47-.306-4.661-7.363-1.048-10.6-3.51-1.473,1.751.03,4.179,1.076,4.294,1.144.174,1.106,2.232,1.219,3.22.052.33.418.563.718.737a2.333,2.333,0,0,1,1.36-1.625c.673.744.1,2.306-.829,4.776",
    transform: "translate(-1123.763 -385.282)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22866",
    "data-name": "Path 22866",
    d: "M1287.4,570.924a5.222,5.222,0,0,1,.755.877l-.164-.048a50.463,50.463,0,0,0-7.071-.374,4.445,4.445,0,0,1,.785-.811,16.189,16.189,0,0,1,5.695.355",
    transform: "translate(-1143.344 -509.175)",
    fill: "#ea7924",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22867",
    "data-name": "Path 22867",
    d: "M970.95,502.762a12.9,12.9,0,0,1-3.109-1.785c-.269-.836-.785-.87-.644-1.6-1.24-1.436-1.524-1.466-2.093-1.733.5-.8,1.653-.155,3.521,1.64,1.263.737,1.809.581,1.622-.47-.763-.729-.755-1.344-.524-1.681.1.092.509.588,1.248,1.347a4.771,4.771,0,0,1,.89,2,.825.825,0,0,0,.134.359,4.647,4.647,0,0,0-1.047,1.925",
    transform: "translate(-861.449 -443.737)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22868",
    "data-name": "Path 22868",
    d: "M1390.142,857.423c-.531.659-1.188,1-2.205,1.962l.008.111-.157.037c-.224.222-.471.474-.741.77.538.43,1.211.134,2.041-.873a3.016,3.016,0,0,1-.882,2.5c-.314.348-.561.622-.755.815q.886,1.488,3.692-1.185a11.392,11.392,0,0,0,.561-2.014,8.244,8.244,0,0,1,.336-1.007,4.05,4.05,0,0,1-1.891-1.111Z",
    transform: "translate(-1238.072 -765.332)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22869",
    "data-name": "Path 22869",
    d: "M1225.419,876.56a188.629,188.629,0,0,1,1.308,25.669c.9,4.524.859,11.758-.135,26.425a13.127,13.127,0,0,1-4.574.207c-2.287-13.683-3.162-20.82-2.624-26.121-.7-3.813-1.659-10.81-2.877-16.252-1.219,5.442-2.183,12.439-2.878,16.252.538,5.3-.336,12.439-2.624,26.121a13.127,13.127,0,0,1-4.574-.207c-.995-14.668-1.039-21.9-.135-26.425-.067-9.617.381-19.583,1.33-25.847q10.932,1.566,17.783.178",
    transform: "translate(-1076.167 -782.255)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22870",
    "data-name": "Path 22870",
    d: "M1202.51,1384.983c.441.333.538,1.9.194,3.087a4.85,4.85,0,0,1-4.208-.185c-.688-.267-1.518-.726-1.5-1.214.029-.933.052-.948,1.988-1.94-.031.185-.06.356-.1.519.083.222.255.385.576.178.358-.222.239-.97,1.241-.993.837-.007.844.785,1.248,1.044.449.3.546-.155.561-.5",
    transform: "translate(-1068.432 -1235.741)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22871",
    "data-name": "Path 22871",
    d: "M1361.406,1384.974c-.433.334-.538,1.9-.186,3.088a4.784,4.784,0,0,0,4.2-.185c.209-.1,1.04-.363,1.107-.592.232-.8.037-1.866-1.592-2.561.029.185.067.363.1.526-.083.214-.255.385-.575.177-.359-.237-.24-.977-1.241-.992-.838-.014-.845.77-1.248,1.036-.449.311-.546-.148-.561-.5",
    transform: "translate(-1214.831 -1235.74)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22872",
    "data-name": "Path 22872",
    d: "M1218.253,1364.037a15.176,15.176,0,0,0-.12,2.983c-.074.156-.217.23-.471.059-.4-.259-.411-1.051-1.247-1.044-1,.022-.883.77-1.241.993-.322.207-.494.044-.576-.178a16.741,16.741,0,0,0,.277-3.029,13.7,13.7,0,0,0,3.379.215",
    transform: "translate(-1084.145 -1217.342)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22873",
    "data-name": "Path 22873",
    d: "M1364.364,1363.969a14.148,14.148,0,0,1,.127,2.984c.074.163.217.237.471.059.4-.266.411-1.051,1.249-1.036,1,.015.882.756,1.241.993.321.207.493.037.576-.178a17.546,17.546,0,0,1-.277-3.036,13.362,13.362,0,0,1-3.386.214",
    transform: "translate(-1217.826 -1217.282)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22874",
    "data-name": "Path 22874",
    d: "M1129.264,582.826a147.651,147.651,0,0,1,4,14.568q3.813,2.632,5.345,3.864-5.393-3.01-6.63-3.739a42.583,42.583,0,0,0-2.107,10.069,64.479,64.479,0,0,1,1.211-10.122q-.628-7.047-1.816-14.641m-8.648-7.522a5.5,5.5,0,0,0-1.637,1.192,10.526,10.526,0,0,1,2.818-.633c-.42-.2-.807-.389-1.181-.559m29.121,11.613a18.989,18.989,0,0,1-.374,2.417c-.441,2.936-1.264,7.06-1.779,13.412a43.748,43.748,0,0,1,1.084,4.931c-.1.022-.195.052-.3.067a27.5,27.5,0,0,0-1.443-4.324,12.428,12.428,0,0,1-2.6.933c.628-.548,1.256-1.074,1.876-1.585a155.14,155.14,0,0,1,3.536-15.852",
    transform: "translate(-998.796 -513.514)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22875",
    "data-name": "Path 22875",
    d: "M1612.009,705.144a3.845,3.845,0,0,1,1.906-.23,30.444,30.444,0,0,0,2.265-2.732s6.01-7.759,6.316-8.2l1.973-10.11,5.613.011s-2.459,10.921-2.691,11.454-9.724,10.01-10.531,10.869c0,0-.531,1.414-.889,2.28a7.133,7.133,0,0,1-1.271,1.732,7.884,7.884,0,0,1-1.457,1.451c-.792.607-.367-.34-.367-.34s1.219-1.385,1.077-1.466c-.1-.074-.725.726-1.584,1.4-.224.178-.441.348-.643.5-.531.407-.98.185-.5-.334a5.952,5.952,0,0,1,.695-.666,4.917,4.917,0,0,0,.613-.652,5.516,5.516,0,0,0,.628-.7c-.037,0-.022-.14-.269.045-.291.207-.784.8-1.241,1.081-.262.156-.777.519-.777.519a5.77,5.77,0,0,1-.949.355c-.255-.252.261-.7.65-.859a3.836,3.836,0,0,1,.733-.6s.926-1,.762-1.147a14.215,14.215,0,0,0-1.45.91c-.688.393-1.45.682-1.569.555-.2-.215.507-.74.507-.74s.516-.333.673-.459c.186-.148.71-.644.71-.644s1.734-1.777,1.577-1.9a1.427,1.427,0,0,0-.844-.223c-.15.067-.343.348-.494.415a.47.47,0,0,1-.546-.148c-.126-.178.441-.807.441-.807a2.545,2.545,0,0,1,.935-.629",
    transform: "translate(-1436.2 -610.425)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22876",
    "data-name": "Path 22876",
    d: "M1677.426,1356.034l.164,3.495c.068.459.344,1.555.337,1.955-.015,1.518-6.794-1.355-5.262-2.014.142-.059.867-.5.919-1.029.075-.792.277-2.391.277-2.391Z",
    transform: "translate(-1492.812 -1210.391)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22877",
    "data-name": "Path 22877",
    d: "M1627.536,1387.8a22.84,22.84,0,0,0,2.407.607c.814.126,1.906-.836,2.481-.57.635.3.546,3.147.546,3.147s-8.543.415-10.942-.385c-.956-.3,2.227-1.747,5.509-2.8",
    transform: "translate(-1447.661 -1238.737)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22878",
    "data-name": "Path 22878",
    d: "M1817.089,1360.586l.165,3.5c.067.444.344,1.547.344,1.947-.023,1.525-6.795-1.362-5.262-2.014.135-.059,1.084-.852,1.136-1.362.075-.8.052-2.059.052-2.059Z",
    transform: "translate(-1617.481 -1214.454)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22879",
    "data-name": "Path 22879",
    d: "M1765.27,1392.289a22.83,22.83,0,0,0,2.407.608c.823.118,1.913-.844,2.489-.578.634.3.634,2.917.634,2.917s-9.133.563-11.271-.082c-.964-.274,2.459-1.814,5.74-2.865",
    transform: "translate(-1570.401 -1242.736)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22880",
    "data-name": "Path 22880",
    d: "M1686.015,889.617l-2.893,1.206-6.353,28.587.03,21.472,4.851.155s2.452-18.754,2.466-20.205c.015-1.466,10.719-25.381,10.719-25.381Z",
    transform: "translate(-1496.677 -794.069)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22881",
    "data-name": "Path 22881",
    d: "M1783.383,897.053s1.891,22.086,1.854,25.8,1.465,24.567,1.465,24.567l4.866.014s.418-6.338,1.038-15.667c.1-1.466-.059-4.413.06-5.93.867-10.876,2.475-21.109,1.8-25.181-.112-.659-.306-2.369-.726-2.806-3.154-3.295-10.359-.8-10.359-.8",
    transform: "translate(-1591.84 -799.898)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22882",
    "data-name": "Path 22882",
    d: "M1729.793,613.792l5.89-.326s.352-5.216.375-7.7c.03-3.017,1.009-7.456.642-7.378a7.192,7.192,0,0,0-3.617,2.259c-2.871,3.865-3.289,13.146-3.289,13.146",
    transform: "translate(-1544.006 -534.118)",
    fill: "#1c2a47",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22883",
    "data-name": "Path 22883",
    d: "M1741.361,596.326s3.348.5,4.231,1.148a11.811,11.811,0,0,1,2.078,2.369s-4.328,19.258-4.365,22.515c-.037,2.5.8,8.677.8,8.677s-12.46.659-17.161-1.244c0,0,1.562-7.315,1.584-9.24s1.981-19.432,2.4-20.65c.382-1.107,1.076-3.091,3.357-3.569a33.715,33.715,0,0,1,7.078-.008",
    transform: "translate(-1541.462 -532.096)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22884",
    "data-name": "Path 22884",
    d: "M1811.818,546.678l.777,5.4s-3.1,6.39-4.9,5.812c-1.518-.478-.523-6.149-.523-6.149a15.381,15.381,0,0,0,.627-4.576c-.231-1.525,4.021-.485,4.021-.485",
    transform: "translate(-1612.786 -487.654)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22885",
    "data-name": "Path 22885",
    d: "M1814.55,547.163c-.231-1.525,4.021-.485,4.021-.485l.067.452a2.451,2.451,0,0,1-.47.74,5.64,5.64,0,0,1-3.753,1.629,8,8,0,0,0,.135-2.336",
    transform: "translate(-1619.539 -487.654)",
    fill: "#f27458",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22886",
    "data-name": "Path 22886",
    d: "M1799.371,464.361c.12-.041.905,6.149-.725,7.83s-4.755,2.214-5.868.859c-1.226-1.488-1.09-8.134,1.421-9.862s5.172,1.173,5.172,1.173",
    transform: "translate(-1599.555 -412.951)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22887",
    "data-name": "Path 22887",
    d: "M1803.226,436.452a6.907,6.907,0,0,1,3.625,2.077c.867.111,2.056.6,3.266,2.613a4.97,4.97,0,0,1-1.435,6.527,3.893,3.893,0,0,0-1.764,2.876l-.269-.818a4.351,4.351,0,0,1-.2-1.881,3.565,3.565,0,0,1,.3-1.133c.433-.9-.9-1.5-1.264-2.247-.276-.581-.283-1.891-.725-2.839l-.531-.733a3.493,3.493,0,0,0-2.467-.714c-1.226.263-1.009-4.257,1.465-3.728",
    transform: "translate(-1607.595 -389.537)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22888",
    "data-name": "Path 22888",
    d: "M1843.088,510.783c-.014.748.329,1.37.77,1.388s.814-.6.837-1.348-.322-1.377-.763-1.388-.821.589-.844,1.347",
    transform: "translate(-1645.132 -454.72)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22889",
    "data-name": "Path 22889",
    d: "M1730.678,621.628c-1.128-.041-2.2,7.334-1.495,8.066s.755,9.833.755,9.833l-10.659-.378v.008c-.209-.148-2.422-1.651-2.736-1.977a2.556,2.556,0,0,0-2.4.274c-.434.459.823.237,1.2.489s-.165.755-.165.755-2.705.355-3.221-.192-1.922-1.526-2.116-.963c-.1.282.614,1.155,1.017,1.525-.508-.385-1.114-.8-1.323-.726-.381.126-.231.607-.022.756.209.133,2.332,1.777,2.668,1.9.321.119,5.307.3,6.166.488,0,0,14.022,3.317,14.823,3.125.7-.171,1.45-4.62,1.487-8.026.037-3.421-.448-14.815-3.984-14.952",
    transform: "translate(-1525.718 -554.862)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22890",
    "data-name": "Path 22890",
    d: "M1876.251,605.878a8.588,8.588,0,0,1,3.969,2.75c1.824,2.066,2.871,13.59,2.871,13.59l-6.391.956-.449-5.572c-2.661-4.053-3.3-8.9,0-11.724",
    transform: "translate(-1672.734 -540.804)",
    fill: "#1c2a47",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22891",
    "data-name": "Path 22891",
    d: "M121.041,493.357c-.673-1.814-1.361-3.624-3.416-4.783a5.426,5.426,0,0,0-5.114-.145c-4.589,2.2-2.526,6.216-5.509,10.447-1.277,1.8-3.184,2.725-4.14,4.62-1.727,3.42-.224,8.985,4.409,12.113,11.361,7.678,17.6-6.012,17.626-8.963.029-2.192-3.424-12.124-3.857-13.29",
    transform: "translate(-91.195 -435.461)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22892",
    "data-name": "Path 22892",
    d: "M283.262,709.792a3.173,3.173,0,0,0-1.546-.237,27.863,27.863,0,0,1-1.974-2.333s-5.247-6.648-5.516-7.019l-2.122-8.53-4.522-.111s2.548,9.2,2.765,9.662,8.372,8.61,9.067,9.359c0,0,.5,1.185.837,1.925a6.756,6.756,0,0,0,1.114,1.481,6.933,6.933,0,0,0,1.256,1.244c.665.533.276-.267.276-.267s-1.061-1.2-.949-1.259c.082-.059.62.629,1.352,1.214.187.148.367.3.538.43.456.355.8.178.39-.267a4.5,4.5,0,0,0-.6-.57,4.487,4.487,0,0,1-.524-.57,6.109,6.109,0,0,1-.545-.592c.029,0,.014-.118.216.045.247.178.681.689,1.061.933.218.141.65.459.65.459a5.734,5.734,0,0,0,.8.392c.194-.2-.262-.667-.583-.807a3.426,3.426,0,0,0-.621-.526s-.792-.859-.672-.977c.1-.1,2.407,1.592,2.586,1.385.149-.178-.524-.718-.524-.718s-.433-.3-.569-.407c-.156-.126-.6-.548-.6-.548s-1.495-1.533-1.368-1.636a1.059,1.059,0,0,1,.666-.17c.127.074.292.311.418.363a.347.347,0,0,0,.434-.111c.09-.148-.4-.681-.4-.681a2.285,2.285,0,0,0-.793-.555",
    transform: "translate(-238.842 -617.286)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22893",
    "data-name": "Path 22893",
    d: "M123.072,696.388c-.329-.274-4.792-4.113-6.788-5.827a2.113,2.113,0,0,1,3.222.677,55.156,55.156,0,0,0,3.566,5.15",
    transform: "translate(-103.795 -615.951)",
    fill: "#233761",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22894",
    "data-name": "Path 22894",
    d: "M215.2,751.538a15.3,15.3,0,0,1-2.855,4.6c-2.75-.037,2.855-4.6,2.855-4.6",
    transform: "translate(-188.861 -670.82)",
    fill: "#233761",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22895",
    "data-name": "Path 22895",
    d: "M187.731,872.058c-.755,1.917-4.627,5.864-8.618,9.58-4.762,4.442-9.695,8.581-9.695,8.581s-2.258.681-1.271-2.606c0,0,5.434-9.9,7.774-12.816a28.637,28.637,0,0,1,2-2.265,31.767,31.767,0,0,1,2.953-2.7s-.307-.489-.8-1.333c-2.437-4.117-9.4-16.733-7.251-22.323a19.617,19.617,0,0,1,9.03-9.78s2.047,8.529,3.767,17.3c1.591,8.07,2.9,16.348,2.107,18.355",
    transform: "translate(-149.865 -746.567)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22896",
    "data-name": "Path 22896",
    d: "M223.2,853.7c-1.182,5.4-3.238,13.046-5.547,14.8-2.437-4.117-9.4-16.733-7.251-22.323a19.616,19.616,0,0,1,9.03-9.781s2.047,8.529,3.767,17.3",
    transform: "translate(-187.443 -746.566)",
    fill: "#1c2a47",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22897",
    "data-name": "Path 22897",
    d: "M179.112,1181.912c-4.762,4.443-9.695,8.581-9.695,8.581s-2.257.681-1.271-2.606c0,0,5.434-9.9,7.774-12.816a28.594,28.594,0,0,1,2-2.265c-.074,2.532-.008,6.812,1.189,9.106",
    transform: "translate(-149.864 -1046.841)",
    fill: "#1c2a47",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22898",
    "data-name": "Path 22898",
    d: "M160.659,849l-.448-1.644c-3.169,1.362-12.483-.622-12.483-.622s-2.78,3.258-1.352,9.862c.7,3.235,3.169,17.015,4.177,21.057.367,1.466.65,2.5.763,2.918h.008a.659.659,0,0,1-.045.377,19.314,19.314,0,0,0-.987,3.221c-2.31,10.691,4.006,22.508,4.006,22.508l1.084-.629s.419-14.253,1.533-20.687a12.436,12.436,0,0,1,.635-2.495,26.491,26.491,0,0,0,1.48-6.878,159.162,159.162,0,0,0,.7-17.77c.1-.007.926-9.218.926-9.218",
    transform: "translate(-130.291 -755.794)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22899",
    "data-name": "Path 22899",
    d: "M141.92,610.47c-1.286-1.933,3.131-9.818,2.974-10.566a20.75,20.75,0,0,0-1.749-4.554,34.114,34.114,0,0,1-1.66-3.565c.225-.315.456-.615.658-.892a8.016,8.016,0,0,0,.778-1.2,1.621,1.621,0,0,0,.179-1.14,4.749,4.749,0,0,0-.283-.818c-.06-.126-.12-.252-.18-.374a11.689,11.689,0,0,0-1.644-2.369,11.3,11.3,0,0,1,4.037-1.418,4.8,4.8,0,0,1,.471-.133c.089-.026.18-.048.269-.067.314-.074.62-.137.89-.185.56-.555,1.225-2.613,1.023-5.646l.277.033,4.529.607s-.014,1.4.06,2.721a5.29,5.29,0,0,0,.411,2.214c.352.03.569.052.569.052v0l.008.008c.254.022.493.044.7.066a.236.236,0,0,0,.052,0c.4.044.732.1,1,.141l.052.015a4.731,4.731,0,0,1,1.039.27v.015c-.037,1.414,2.264,3.891,2.1,7.089,0,.126-1.18,8.507-1.173,8.641.1,2.384,1.278,9.107,1.278,9.107,1.076,2.088-15.973,3.924-16.668,1.94",
    transform: "translate(-125.85 -515.513)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22900",
    "data-name": "Path 22900",
    d: "M210.383,578.49s-.014,1.4.068,2.721c-2.511.081-3.976-2.1-4.6-3.325Z",
    transform: "translate(-183.744 -515.819)",
    fill: "#ed9760",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22901",
    "data-name": "Path 22901",
    d: "M203.176,513.213s-5.919.456-6.151-3.206-1.151-6.064,2.623-6.508,4.6.9,4.971,2.106.1,7.393-1.443,7.608",
    transform: "translate(-175.626 -449.343)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22902",
    "data-name": "Path 22902",
    d: "M189.332,497.584c-.987-1.044-1.659-.763-2.033-.4a4.167,4.167,0,0,0-5.277,1.166,6.956,6.956,0,0,1-2.056,4.269s1.129.6,3.58-.189a4.246,4.246,0,0,0,1.928-1.5,13.773,13.773,0,0,1-2.2,3.025c2.893-1.544,3.827-5.72,3.924-6.157a4.629,4.629,0,0,1,1.4,1.629c.351.914.6,2.821,1.166,2.725,0,0,1.047-2.995-.434-4.561",
    transform: "translate(-160.637 -443.346)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22903",
    "data-name": "Path 22903",
    d: "M212.219,1367.649h-9.193a3.75,3.75,0,0,1,.262-2.443c.538-.874.2-1.466-.03-2.206a3.572,3.572,0,0,0,1.509.4,4.559,4.559,0,0,0,1.608-.607,28.6,28.6,0,0,0,2.384,2.858c.6.43,3.274.282,3.46,2",
    transform: "translate(-181.133 -1216.422)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22904",
    "data-name": "Path 22904",
    d: "M133.457,1323.191l-3.46-8.432a3.806,3.806,0,0,1,2.377-.681,1.785,1.785,0,0,0,1.943-.852,3.437,3.437,0,0,0,.315,1.533,3.174,3.174,0,0,0,.957,1.073,31.58,31.58,0,0,0-1.562,3.428c-.18.711.972,3.11-.568,3.931",
    transform: "translate(-116.035 -1172.18)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22905",
    "data-name": "Path 22905",
    d: "M157.31,646.832c0-.074.366-2.71.688-5.053a7.561,7.561,0,0,0,2.316-.589c-.045-1.018-.725-9.762-4.432-10.251-.18-.048-.366-.089-.538-.122a.274.274,0,0,1-.052-.015c-.455-.081-.859-.126-1-.137a.387.387,0,0,1-.052-.007,33.966,33.966,0,0,1,1.083,3.476c-.023.363-3.573.489-5.9.518s-3.626-3.809-3.648-3.869c-.089.018-.18.04-.269.066-.135.03-3.229.5-4.507,1.551a11.681,11.681,0,0,1,1.644,2.369c.06.122.12.248.18.374a4.758,4.758,0,0,1,.283.818,1.621,1.621,0,0,1-.179,1.14,8.009,8.009,0,0,1-.778,1.2c-.2.277-.433.577-.658.892a8.4,8.4,0,0,0,.4,1v0c.337.726.8,1.615,1.264,2.565a20.746,20.746,0,0,1,1.749,4.554c.157.748-4.26,8.633-2.974,10.566.209.592,1.846.844,4.013.851,5.18.022,13.417-1.325,12.655-2.791,0,0-1.18-6.723-1.278-9.106",
    transform: "translate(-125.85 -562.923)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22906",
    "data-name": "Path 22906",
    d: "M151.685,728.57c-2.167-.007-3.8-.259-4.013-.851-1.286-1.933,3.131-9.818,2.974-10.566A20.753,20.753,0,0,0,148.9,712.6c-.464-.951-.927-1.84-1.264-2.566v0c.187-.714.292-1.129.292-1.129s4.7,5.416,5.785,7.978c.845,2-1.129,8.833-2.026,11.691",
    transform: "translate(-131.602 -632.762)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22907",
    "data-name": "Path 22907",
    d: "M76.878,717.321l-.934,1.6a24.643,24.643,0,0,1-9.791-7.626c-.209-3.006,1.21-6.456,2.907-9.437.284-.492.569-.974.86-1.436a38.165,38.165,0,0,0,4.485,3.317c-.255.407-.546.892-.867,1.418-1.331,2.169-3.042,4.938-3.266,5.16-.367.363,6.607,7,6.607,7",
    transform: "translate(-59.029 -625.193)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22908",
    "data-name": "Path 22908",
    d: "M94.824,658.021c-2.945-.192-5.12-3.983-5.12-3.983a36.725,36.725,0,0,1,5.509-7.145c8.169,3.088.942,10.262-.389,11.128",
    transform: "translate(-80.069 -577.414)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22909",
    "data-name": "Path 22909",
    d: "M153.5,847.521a1.829,1.829,0,0,0,.83-.348c.329-.288,1.375-1.088,1.435-.836s-.762.629-.329.7a17.25,17.25,0,0,1,1.787-.126c.673.1,1.712,1.644,1.39,1.829s-1.487-.429-1.793-.215-2.5,1.4-4.253.6.934-1.6.934-1.6",
    transform: "translate(-135.653 -755.394)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22910",
    "data-name": "Path 22910",
    d: "M486.674,228.128c-.815-1.921-1.248-2.939-.5-5.542.59-2.077,1.308-4.335.314-6.678-1.054-2.484-3.767-4.213-7.878-2.5a10.308,10.308,0,0,0-4.193,3.147l2.174,2.684a5.8,5.8,0,0,1,2.52-2.051c1.622-.674,2.825-.144,3.379,1.155.515,1.214.239,2.625-.246,4.487a8.5,8.5,0,0,0,.157,5.586c.111.255.186.355.628,1.233Zm1.12,7.841a2.6,2.6,0,0,0,1.413-3.613,2.718,2.718,0,1,0-1.413,3.613",
    transform: "translate(-423.462 -189.872)",
    fill: "#d2e4fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22911",
    "data-name": "Path 22911",
    d: "M20.064,277.762c-.822-1.921-1.248-2.936-.508-5.538.59-2.077,1.315-4.339.313-6.682-1.054-2.484-3.767-4.213-7.871-2.5a10.456,10.456,0,0,0-4.2,3.147l2.174,2.68a5.821,5.821,0,0,1,2.519-2.044c1.63-.677,2.826-.148,3.379,1.151.515,1.214.246,2.625-.24,4.486a8.414,8.414,0,0,0,.157,5.587c.1.252.18.355.621,1.236Zm1.114,7.845a2.609,2.609,0,0,0,1.42-3.617,2.721,2.721,0,1,0-1.42,3.617",
    transform: "translate(-6.961 -234.175)",
    fill: "#bec1cd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22912",
    "data-name": "Path 22912",
    d: "M238.964,158.9c.075-2.669.112-4.083,2.37-6.73,1.809-2.11,3.849-4.372,3.946-7.63.1-3.454-2.145-6.893-7.855-7.052a13.51,13.51,0,0,0-6.585,1.466l1.113,4.272a7.505,7.505,0,0,1,4.037-1.066c2.257.063,3.371,1.314,3.319,3.117-.046,1.688-1.122,3.191-2.684,5.112a10.831,10.831,0,0,0-2.8,6.6c-.008.351.022.511.067,1.769Zm-2.893,9.74a3.368,3.368,0,0,0,3.588-3.476,3.409,3.409,0,0,0-3.386-3.747,3.456,3.456,0,0,0-3.588,3.554,3.378,3.378,0,0,0,3.386,3.669",
    transform: "translate(-206.046 -122.715)",
    fill: "#d2e4fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22913",
    "data-name": "Path 22913",
    d: "M894.17,23.5c.082-2.669.119-4.083,2.376-6.73,1.8-2.114,3.849-4.372,3.94-7.63.1-3.454-2.139-6.9-7.849-7.052a13.4,13.4,0,0,0-6.585,1.466l1.106,4.272a7.492,7.492,0,0,1,4.037-1.066c2.265.063,3.378,1.311,3.326,3.117-.052,1.688-1.121,3.191-2.683,5.112a10.793,10.793,0,0,0-2.8,6.6c-.014.351.023.511.068,1.766Zm-2.893,9.74a3.37,3.37,0,0,0,3.6-3.476,3.406,3.406,0,0,0-3.386-3.746,3.461,3.461,0,0,0-3.594,3.554,3.388,3.388,0,0,0,3.385,3.668",
    transform: "translate(-790.886 -1.863)",
    fill: "#699dee",
    fillRule: "evenodd",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22914",
    "data-name": "Path 22914",
    d: "M703.94,166.972c.09-2.31.143-3.535,2.123-5.8,1.584-1.81,3.379-3.746,3.491-6.564.119-2.991-1.786-5.99-6.727-6.186a11.724,11.724,0,0,0-5.718,1.207l.919,3.709a6.424,6.424,0,0,1,3.507-.881c1.95.078,2.907,1.166,2.84,2.732-.053,1.459-1,2.751-2.37,4.394a9.4,9.4,0,0,0-2.5,5.686c-.007.307.015.444.046,1.532Zm-2.6,8.4a2.912,2.912,0,0,0,3.139-2.972,2.949,2.949,0,0,0-2.892-3.28,2.992,2.992,0,0,0-3.14,3.043,2.929,2.929,0,0,0,2.893,3.209",
    transform: "translate(-622.237 -132.469)",
    fill: "#bec1cd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22915",
    "data-name": "Path 22915",
    d: "M1120.72,112.249c.12-2.851.18-4.361,2.616-7.163,1.959-2.228,4.171-4.62,4.313-8.1.142-3.687-2.205-7.389-8.3-7.63a14.427,14.427,0,0,0-7.056,1.488l1.13,4.58a7.968,7.968,0,0,1,4.328-1.092c2.407.1,3.587,1.444,3.505,3.373-.068,1.8-1.233,3.391-2.93,5.423a11.541,11.541,0,0,0-3.073,7.015c-.015.381.023.548.053,1.891Zm-3.206,10.366a3.592,3.592,0,0,0,3.872-3.669,3.635,3.635,0,0,0-3.566-4.043,3.693,3.693,0,0,0-3.879,3.754,3.612,3.612,0,0,0,3.573,3.958",
    transform: "translate(-992.831 -79.75)",
    fill: "#d2e4fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22916",
    "data-name": "Path 22916",
    d: "M1739.9,174.027c-.837-2.069-1.278-3.165-.426-5.934.673-2.21,1.488-4.612.472-7.141-1.076-2.68-3.947-4.579-8.372-2.832a11.169,11.169,0,0,0-4.56,3.28l2.28,2.913a6.155,6.155,0,0,1,2.736-2.14c1.75-.692,3.028-.1,3.588,1.3.523,1.311.2,2.813-.351,4.8a9.063,9.063,0,0,0,.052,5.979c.112.27.194.381.643,1.333Zm1.031,8.415a2.79,2.79,0,0,0,1.592-3.839,2.91,2.91,0,1,0-1.592,3.839",
    transform: "translate(-1541.525 -140.535)",
    fill: "#d2e4fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22917",
    "data-name": "Path 22917",
    d: "M1283.431,16.587c-.83-2.069-1.271-3.169-.426-5.938.68-2.206,1.495-4.609.478-7.137-1.084-2.68-3.947-4.583-8.379-2.836a11.106,11.106,0,0,0-4.552,3.283l2.273,2.91a6.243,6.243,0,0,1,2.736-2.14c1.756-.688,3.027-.1,3.6,1.3.523,1.307.2,2.814-.352,4.794a8.979,8.979,0,0,0,.052,5.979c.112.274.187.385.643,1.336ZM1284.469,25a2.792,2.792,0,0,0,1.593-3.839,2.912,2.912,0,1,0-5.411,2.132A2.847,2.847,0,0,0,1284.469,25",
    transform: "translate(-1134.089 -0.002)",
    fill: "#bad2f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22918",
    "data-name": "Path 22918",
    d: "M1495.361,165.292a6.048,6.048,0,0,1,2.407-4.409c1.487-1.266,3.161-2.606,3.594-4.861.456-2.384-.71-5.02-4.649-5.764a9.483,9.483,0,0,0-4.738.292l.283,3.087a5.237,5.237,0,0,1,2.923-.292c1.563.292,2.2,1.284,1.958,2.528-.224,1.166-1.135,2.092-2.444,3.254a7.621,7.621,0,0,0-2.683,4.268c-.052.245-.045.359-.157,1.237Zm-3.1,6.441a2.542,2.542,0,0,0,.957-4.99,2.443,2.443,0,0,0-2.9,2.07,2.375,2.375,0,0,0,1.943,2.921",
    transform: "translate(-1330.203 -133.97)",
    fill: "#d2e4fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22919",
    "data-name": "Path 22919",
    d: "M1542.019,217.9c.142-3.617.216-5.531,3.319-9.088,2.481-2.832,5.292-5.868,5.464-10.284.194-4.683-2.8-9.385-10.532-9.688a18.272,18.272,0,0,0-8.955,1.888l1.436,5.812a10.134,10.134,0,0,1,5.494-1.381c3.057.118,4.552,1.829,4.455,4.276-.09,2.288-1.57,4.309-3.715,6.889-2.549,3.047-3.789,5.927-3.909,8.907-.022.477.023.692.068,2.4Zm-4.081,13.164a4.561,4.561,0,0,0,4.918-4.657,4.619,4.619,0,0,0-4.529-5.134,4.684,4.684,0,0,0-4.919,4.765,4.58,4.58,0,0,0,4.53,5.027",
    transform: "translate(-1366.845 -168.543)",
    fill: "#bec1cd",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskRecruiterIcon);
export default __webpack_public_path__ + "static/media/ask-recruiter-icon.1f77863aa963e468cc491e7faa195c43.svg";
export { ForwardRef as ReactComponent };